import { Button, Divider, FormLabel, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AsyncButton from "../../../../components/buttons/AsyncButton";
import LogoSection from "../../../../components/logoSection/LogoSection";
import useRequestOtpMutation from "../../../../hooks/graphql-hooks/mutations/useRequestOtpMutation";
import { isNullOrEmpty } from "../../../../utils/helper";
import useEmailValidation from "../useEmailValidation";
import "./Login.scss";

interface LoginProps {
  setUsedEmail: (email: string) => void;
}

const Login = (props: LoginProps) => {
  const { t } = useTranslation();

  const [requestOtp, { loading }] = useRequestOtpMutation({
    dataAction: () => setUsedEmail(email),
    errorAction(error) {
      setEmailError(t(error.message || ""));
    },
  });

  const { setUsedEmail } = props;

  const [email, setEmail] = useState<string>("");
  const validationError = useEmailValidation({ email });

  //helperState to combine requestOtpError and validationError
  const [emailError, setEmailError] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleClickLogin = () => {
    if (loading || !isNullOrEmpty(validationError) || isNullOrEmpty(email))
      return;

    requestOtp({ variables: { otpInput: { email } } }).catch(() => {});
  };

  useEffect(() => {
    setEmailError(validationError);
  }, [validationError]);

  return (
    <div className="login-box-content">
      <div className="login-box-content-form">
        <LogoSection variant="platbricks" />
        <div className="login-box-content-form-input">
          <FormLabel required>{t("email")}</FormLabel>
          <TextField
            autoFocus
            data-testid="login-form-textfield-email"
            id={"email"}
            className="input-element"
            value={email}
            onChange={handleChange}
            onKeyDown={(e) => e.key === "Enter" && handleClickLogin()}
            variant="outlined"
            placeholder={t("emailPlaceholder")}
            required
            error={!isNullOrEmpty(emailError)}
            helperText={emailError}
          />
        </div>
        <AsyncButton
          disabled={!!validationError || isNullOrEmpty(email) || loading}
          sendRequest={handleClickLogin}
          loading={loading}
        >
          {t("login")}
        </AsyncButton>
      </div>

      <div className="login-box-content-cant-login">
        <Divider />
        <Button
          className="login-box-content-cant-login-button"
          variant="text"
          onClick={() => {}}
        >
          {t("cantLogin")}
        </Button>
      </div>
    </div>
  );
};

export default Login;
